import { Component, OnInit } from "@angular/core";
// import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import {
  NgbModal,
  NgbModalRef,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";
import { UserMgmtService } from "../user.service";
import { RolesService } from "../../roles/roles.service";
import { CommonService } from "../../../shared/common.service";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { MobileDetectionService } from "../../../shared/services/mobile-detection.service";
import { ResetEventService } from "../../../shared/services/reset-event.service";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-userlist",
  templateUrl: "./userlist.component.html",
  styleUrls: ["./userlist.component.scss"],
})
export class UserlistComponent implements OnInit {
  userDetails;
  auditLogsList: [];
  showCouponList: boolean = false;
  resetPass;
  showaAudit: boolean = false;
  query: string;
  roleList;
  passwordForm: FormGroup;
  statusFormSubmitted: boolean = false;
  hasWriteAccess: boolean = false;
  hasReadAccess: boolean = false;
  editUserForm: FormGroup;

  statusForm: FormGroup;
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "inactive", name: "Inactive" },
    { id: "blocked", name: "Block" },
  ];
  currentUser: any = null;
  modaldata;
  stateList = [];
  roles = [];
  // END - Update user variable
  // filters
  searchStartDate: string;
  searchEndDate: string;
  searchUserStatus: string = "";
  searchBy: string = "all";
  searchText1: string;
  searchText2: string;
  searchText3: string;
  // filters end

  userList = [];
  couponList = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  pageLimit: number = 20;
  userSearchType: number = 0;
  minDate: any;
  maxDate: any;
  isLoading: boolean = false;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  searchStatus = "";
  emailPattern =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  mobilePattern = /^[0][1-9][0-9]*$/;

  private modalRef: NgbModalRef;
  searchEndTime: any;
  searchStartTime: string | number | Date;
  description: any;
  offset: number;
  searchfilter: boolean;
  userId: any;
  showCityList: boolean;
  cityList: any;
  citySearch: any;
  public isMobile: boolean;
  pagelimit: any = 20;
  searchTextChanged = new Subject<string>();

  constructor(
    private userMgmtService: UserMgmtService,
    private modalService: NgbModal,
    private userService: UserMgmtService,
    private roleService: RolesService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private _snackBar: MatSnackBar,
    private mobileService: MobileDetectionService,
    private resetEventService: ResetEventService
  ) {}

  ngOnInit() {
    this.mobileService.isMobile$.subscribe((isMobile) => {
      console.log("Mobile View:", isMobile);
      this.isMobile = isMobile;
    });

    this.resetEventService.reset$.subscribe(() => {
      this.onReset();
    });

    this.searchTextChanged.pipe(debounceTime(1000)).subscribe((newText) => {
      this.searchText1 = newText;
      this.searchFiltersBtn();
    });

    // const perm = this.commonService.getPermissions("users");
    // this.hasWriteAccess = perm === "W";
    // this.hasReadAccess = perm === "R" || perm === "W";
    this.getUserList();
    this.currentUser = { role: localStorage.getItem("role") }; // this.getCityList();
  }
  showDescModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    this.description = row;

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.editUserForm.reset();
        this.currentUser = null;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.editUserForm.reset();
        this.currentUser = null;
      }
    );
  }

  openModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    this.description = row.description;
    this.editUserForm.patchValue({
      fullName: row["fullName"],
      email: row["email"],
      address: row["address"],
      mobile: row["mobile"],
      stateId: row["stateId"],
      role: row["role"],
    });
    this.currentUser = { ...row };

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.editUserForm.reset();
        this.currentUser = null;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.editUserForm.reset();
        this.currentUser = null;
      }
    );
  }

  updatePasswordModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.resetPass = row;
    this.statusFormSubmitted = false;

    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  resetPasword() {
    this.isLoading = true;
    let request = {
      userId: this.resetPass["userId"],
      newPassword: this.passwordForm.value.password,
    };
    this.userMgmtService.resetPassword(request).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.passwordForm.reset();
          this.modalRef.close();
          this._snackBar.open("Password reset successfully!", "", {
            duration: 5000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
          // Swal.fire("Success", "Password reset successfully!", "success");
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  showDesc(row) {
    Swal.fire({
      text: row.description,

      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: "Ok",
    }).then((result) => {});
    history.pushState(null, "", null);
  }

  // DeleteCoupon(row) {
  //   Swal.fire({
  //     title: "Delete Coupon: " + row.code,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, Delete it!",
  //   }).then((result) => {
  //     if (result.value) {
  //       this.isLoading = true;
  //       this.userMgmtService.deleteCoupon(row.couponId).subscribe(
  //         (res) => {
  //           this.isLoading = false;
  //           if (res["message"] == "Success") {
  //             Swal.fire("Success", "Coupon deleted successfully!", "success");
  //           } else {
  //             Swal.fire("Error", res.data, "error");
  //           }
  //           this.getUserList();
  //         },
  //         (err) => {
  //           this.isLoading = false;
  //         }
  //       );
  //     }
  //   });
  // }

  queryParams() {
    this.offset = this.pageLimit * this.currentPage;
    let query = "";
    query = query + "&limit=" + this.pageLimit + "&offset=" + this.offset;
    if (this.searchText1) {
      query = query + "&text=" + this.searchText1.trim();
    }
    if (this.citySearch) {
      query = query + "&cityId=" + this.citySearch.trim();
    }
    if (this.userId) {
      query = query + "&userId=" + this.userId;
    }
    if (this.searchStatus) {
      query = query + "&status=" + this.searchStatus;
    }

    if (this.searchStartDate && this.searchStartDate != "") {
      // convert to epoch time
      let startDate = new Date(this.searchStartDate);
      query = query + "&startDate=" + Math.floor(startDate.getTime() / 1000);
    }
    if (this.searchEndDate && this.searchEndDate != "") {
      // convert to epoch time
      let endDate = new Date(this.searchEndDate);
      endDate.setDate(endDate.getDate() + 1);
      query = query + "&endDate=" + Math.floor(endDate.getTime() / 1000 - 1);
    }
    return query;
  }
  total: number = 0;
  // pagelimit: number = 5;
  totalPage: number;
  currentPage: number = 0;
  SetPage() {
    this.totalPage = 0;
    this.totalPage = this.total / this.pageLimit;
    this.totalPage = Math.ceil(this.totalPage);
    if (this.totalPage == 1 || this.total <= this.pageLimit) {
      this.totalPage = 1;
    }
  }
  changeEndDate() {
    this.maxDate = this.searchEndDate;
    this.searchFiltersBtn();
  }
  changeStartDate() {
    this.minDate = this.searchStartDate;
    this.searchFiltersBtn();
  }
  nextPage() {
    this.currentPage = this.currentPage + 1;
    this.getUserList();
  }
  prevPage() {
    this.currentPage = this.currentPage - 1;
    this.getUserList();
  }
  changePageLimit() {
    this.currentPage = 0;
    this.getUserList();
  }
  // GET USERS (By Default ALL)
  getUserList() {
    this.showCouponList = false;
    this.isLoading = true;
    var queryValue = this.queryParams();
    // this.isLoading = true;

    this.userMgmtService.getUserListApi(queryValue).subscribe(
      (res) => {
        if (res["message"] == "Success") {
          this.total = res["data"].totalCount;
          // console.log(this.total);
          this.SetPage();
          this.couponList = res["data"]["response"];
          if (this.couponList.length > 0) {
            this.showCouponList = true;
          }

          // console.log(this.userList)
        } else {
          this.couponList = [];
        }
        setTimeout(() => {
          this.isLoading = false;
        }, 400);
      },
      (err) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 400);
      }
    );
  }
  getUserList2() {
    this.showCouponList = false;
    this.isLoading2 = true;
    var queryValue = this.queryParams();
    // this.isLoading = true;

    this.userMgmtService.getUserListApi(queryValue).subscribe(
      (res) => {
        this.isLoading2 = false;
        if (res["message"] == "Success") {
          this.total = res["data"].totalCount;
          console.log(this.total, "this total");
          // this.SetPage();
          this.couponList = res["data"]["response"];
          if (this.couponList.length > 0) {
            this.showCouponList = true;
          }
          this.isLoading2 = false;
          // console.log(this.userList)
        } else {
          this.isLoading2 = false;
          this.couponList = [];
        }
        setTimeout(() => {
          this.isLoading2 = false;
        }, 400);
      },
      (err) => {
        setTimeout(() => {
          this.isLoading2 = false;
        }, 400);
      }
    );
  }
  openModalReset(row, content, btn) {
    this.prepareUpdateStatusForm();
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
      centered: true,
    };
    this.userDetails = row;

    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  onReset() {
    this.isLoading = true;
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.isLoading = false;
    }, 2000);
    (this.maxDate = ""),
      (this.minDate = ""),
      (this.searchStatus = ""),
      (this.searchText1 = ""),
      (this.citySearch = ""),
      (this.searchText2 = ""),
      (this.searchText3 = ""),
      (this.searchBy = ""),
      (this.searchStartDate = ""),
      (this.searchEndDate = "");
    this.getUserList();
  }

  searchFiltersBtn() {
    this.currentPage = 0;
    this.currentPage = 0;
    // this.searchfilter =  true;
    this.getUserList2();
  }

  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]],
    });
  }

  updateUserStatusModal(row, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "md",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();

    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  updateUserStatusForm(test) {
    // debugger;
    this.statusFormSubmitted = true;
    if (this.statusForm.valid) {
      this.isLoading = true;
      let finalObj = {
        userId: this.userDetails["_id"],
        status: this.statusForm.controls.newStatus.value,
      };
      this.userMgmtService.updateUserStatus(finalObj).subscribe(
        (data) => {
          this.isLoading = false;
          if ((data["message"] = "Success")) {
            this._snackBar.open("User status updated successfully!", "", {
              duration: 5000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            // Swal.fire("Success", "User status updated successfully!", "success");
            this.modalRef.close();
            this.getUserList();
          } else {
            Swal.fire("Error", data.data, "error");
          }
        },
        (err) => {
          this.isLoading = false;
          Swal.fire("Error", err.error.data, "error");
          this.modalRef.close();
          this.getUserList();
        }
      );
    }
  }

  onlyAlphabets(e) {
    return (
      (e.charCode > 64 && e.charCode < 91) ||
      (e.charCode > 96 && e.charCode < 123) ||
      e.charCode == 32 ||
      e.charCode == 45
    );
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  auditModal(userId, content, btn) {
    this.modelOptions = {
      backdrop: "static",
      keyboard: false,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    // this.auditLogsList = row;
    this.getAuditLogsList(userId);
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
        this.auditLogsList = [];
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  getAuditLogsList(userId) {
    this.showaAudit = false;
    this.isLoading = true;
    this.userMgmtService.getAuditLogsListApi(userId).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.auditLogsList = res["data"]["auditLog"];
          if (this.auditLogsList.length > 0) {
            this.showaAudit = true;
          }
          // console.log(this.userList)
        } else {
          this.auditLogsList = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  getCityList() {
    this.showCityList = false;
    this.isLoading = true;
    var queryValue = "type=all";

    this.userService.getCityListApi(queryValue).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.cityList = res["data"]["city"];

          // console.log(this.cityList)
        } else {
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    const atBottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + 10;

    if (atBottom && !this.isLoading) {
      this.loadMore();
    }
  }
  isLoading2: boolean = false;
  private loadMore(): void {
    if (this.total < this.pageLimit) {
      this.isLoading2 = false;
      return;
    }
    this.pageLimit += 40;
    this.getUserList2();
  }
}
